import { Component, Renderer2, ViewChild, ViewEncapsulation } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { SiriusBaseComponent } from "sirius-framework";
import { LoginComponent } from "../shared/components/login/login.component";
import { Images } from "../shared/models/images.model";
import { Location } from '@angular/common';
import { CommonService } from "../shared/service/shared.service";
import { LandingLoginModel } from "./landing-login.model";
import { LandingLoginService } from "./landing-login.service";

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'landing-login',
    templateUrl: './landing-login-component.html',
    styleUrls: ['./landing-login-component.css']
})
export class LandingLoginComponent extends SiriusBaseComponent<LandingLoginModel> {

    apiData: LandingLoginModel;
    loggedIn: boolean = false;
    public bannerText = 'Güvenli Ödeme Sistemi';
    public bannerButtonTextBeforeLogin = 'Kayıt';
    public bannerButtonTextAfterLogin = 'Giriş';
    public bannerButtonLinkBeforeLogin = '';
    public bannerButtonLinkAfterLogin = '';
    _images = Images;
    isTop = true;

    isSubmitted: boolean = false;
    @ViewChild(LoginComponent) loginComponent: LoginComponent;
  kvkkClickableLink: any;
  //goToLandingIntervalId: Time;
    
    constructor(private service: LandingLoginService, private router: Router,
        private commonService: CommonService, private locationService: Location,
        private domSanitizer: DomSanitizer, private renderer: Renderer2) {
        super();
        this.commonService.navigationService = this.navigationService;
        this.commonService.sessionService = this.sessionService;
        this.commonService.dataService = this.dataService;
        
        document.title =  "Güvenli Ödeme Sistemi | QNB";

    } 

    OnInit() { 
        //this.goToLandingIntervalId = setTimeout(() => {
        //    this.commonService.logOutClientNoRoute();
        //    this.router.navigateByUrl(SharedModel.PageName_Landing); 
        //}, 600000);
    }

    ngOnDestroy() {
        //if (this.goToLandingIntervalId) {
        //    clearInterval(this.goToLandingIntervalId);
        //}
    }
     
    okErrorPopup(event: any) {
        this.sessionService.resetIdleTimeout(); 
        this.commonService.logOut(false);
    } 
          
    isLoggedIn(): boolean {
        return this.loggedIn;
    }

    loginButtonClick() {
        this.loggedIn = !this.loggedIn;
    }

    isScrollTop(isTop: boolean) {
        this.isTop = isTop;
    }
}
